import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function BackButton({ to = "/dashboard", label = "Nazad" }) {
  return (
    <Link
      to={to}
      className="flex items-center gap-2 text-xs uppercase tracking-widest text-zinc-400 hover:text-[#22ff77] transition-colors"
    >
      <ArrowLeft className="w-3 h-3" /> {label}
    </Link>
  );
}
